// Extracts the Dailymotion video ID from various URL formats
// Supports:
// - https://dailymotion.com/video/VIDEO_ID
// - https://dai.ly/VIDEO_ID
// - https://www.dailymotion.com/embed/video/VIDEO_ID
export const extractDailymotionVideoId = (url) => {
  if (!url) return null;

  // Pattern to match Dailymotion video IDs (alphanumeric)
  const patterns = [
    // dailymotion.com/video/VIDEO_ID
    /(?:dailymotion\.com\/video\/)([a-zA-Z0-9]+)/,
    // dai.ly/VIDEO_ID
    /(?:dai\.ly\/)([a-zA-Z0-9]+)/,
    // dailymotion.com/embed/video/VIDEO_ID
    /(?:dailymotion\.com\/embed\/video\/)([a-zA-Z0-9]+)/,
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
};

// Converts any Dailymotion URL to a proper embed URL
// Returns: https://www.dailymotion.com/embed/video/VIDEO_ID with parameters to disable suggestions
export const convertToDailymotionEmbedUrl = (url) => {
  const videoId = extractDailymotionVideoId(url);
  if (!videoId) {
    return url;
  }

  return `https://www.dailymotion.com/embed/video/${videoId}?endscreen-enable=0&queue-enable=0&sharing-enable=0&ui-logo=0`;
};

// Validates if a URL is a valid Dailymotion video URL
export const isValidDailymotionUrl = (url) => {
  return extractDailymotionVideoId(url) !== null;
};
